import Cookies from "universal-cookie";
import { AUTH_COOKIE_DOMAIN } from "../constants";

export const setCookie = (
  id,
  data,
  expires,
  domain = AUTH_COOKIE_DOMAIN,
  path = "/"
) => {
  const cookies = new Cookies();
  cookies.set(id, data, { path, expires, domain });
};

export const getCookie = (id, defaultValue) => {
  const cookies = new Cookies();
  const data = cookies.get(id);

  if (data) return data;
  if (defaultValue) return defaultValue;

  return null;
};

export const removeCookie = (id, domain = AUTH_COOKIE_DOMAIN, path = "/") => {
  const cookies = new Cookies();
  return cookies.remove(id, { path, domain });
};

export const clearAllCookies = (path = '/', domain = AUTH_COOKIE_DOMAIN) => {
  const cookies = new Cookies();
  const allCookies = cookies.getAll();

  Object.keys(allCookies).forEach((cookie) => {
    cookies.remove(cookie, { path, domain });
  });
}